import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"
import ResponsiveImage from "../components/ResponsiveImage"
import { useMediaQuery } from "react-responsive"

const AloApparelBrief = () => {
    const isMobileOrTablet = useMediaQuery({ maxWidth: 1024 })
    
    // Define images array in order
    const images = [
        "alo design packet_Blouse Sketch.webp",
        "alo design packet_Blouse Color.webp",
        "alo design packet_Guava Sketch.webp",
        "alo design packet_Guava Color.webp",
        "alo design packet_Titan Sketch.webp",
        "alo design packet_Titan Color.webp",
        "alo design packet_Tundra Sketch.webp",
        "alo design packet_Tundra Color.webp",
        "alo design packet_Waterfall Sketch.webp",
        "alo design packet_Waterfall Color.webp"
    ]
    
    // Function to create an open in new tab button
    const OpenInNewTabButton = ({ imagePath }) => (
        <a 
            href={imagePath} 
            target="_blank" 
            rel="noopener noreferrer"
            className="open-in-new-tab-btn"
        >
            Open in new tab
        </a>
    )

    return (
        <div>
            <Header />
            <ProjectNavigation currentProject="/alo-apparel-brief" />
            
            <div style={{
                textAlign: "center",
                padding: "30px 0 20px",
                marginBottom: "10px"
            }}>
                <h1 style={{ 
                    fontSize: "32px",
                    margin: "0",
                    fontWeight: "bold"
                }}>ALO Apparel Brief</h1>
            </div>

            <main>
                <div style={{ 
                    padding: "20px",
                    margin: "0 auto"
                }}>
                    <div style={{ 
                        display: "flex",
                        flexDirection: "column",
                        gap: "40px",
                        marginBottom: "50px"
                    }}>
                        {images.map((image, index) => (
                            <div key={`image-${index}`}>
                                <div style={{ 
                                    display: "flex",
                                    justifyContent: "center",
                                    height: "auto",
                                    margin: "0 auto"
                                }}>
                                    <ResponsiveImage
                                        src={`/images/projects/alo design packet/${image}`}
                                        alt={`Alo design ${image}`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "contain"
                                        }}
                                        priority={index === 0}
                                        loading={index < 3 ? "eager" : "lazy"}
                                        sizes="100vw"
                                    />
                                </div>
                                <div style={{ 
                                    display: 'flex', 
                                    justifyContent: 'flex-end',
                                    margin: "0 auto"
                                }}>
                                    {isMobileOrTablet && <OpenInNewTabButton imagePath={`/images/projects/alo design packet/${image}`} />}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    )
}

export default AloApparelBrief